import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
import type { Locale } from '@/shared/i18n/locales';

const MODULE = 'pix-med';

// `eager`: título do manifesto no ⌘K e no breadcrumb antes de a tela abrir (A07).
registerModuleCatalog(MODULE, (locale: Locale) => import(`./locales/${locale}.po`), { eager: true });

/** Carrega o catálogo do módulo no idioma ativo (a rota chama antes de desenhar a tela). */
export function loadPixMedMessages(): Promise<void> {
  return ensureModuleMessages(MODULE);
}
